// ShiftBreakComponent

const ShiftBreakComponent = ({ shiftTimes, handleRemoveTime }) => {
  return (
    <div>
      {shiftTimes?.map((value, id) => (
        <div key={id} className="flex items-center gap-3">
          <div className="grid grid-cols-2 gap-5 mt-2 w-full">
            <div className="grid grid-cols-2 gap-3">
              <div className="border p-2 w-full rounded-lg ">
                <p>{value?.startTimeHour}</p>
              </div>
              <div className="border p-2 w-full rounded-lg ">
                <p>{value?.startTimeMinute}</p>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div className="border p-2 w-full rounded-lg ">
                <p>{value?.endTimeHour}</p>
              </div>
              <div className="border p-2 w-full rounded-lg ">
                <p>{value?.endTimeMinute}</p>
              </div>
            </div>
          </div>
          <button className="text-[#0068FF] text-lg cursor-pointer" onClick={() => handleRemoveTime(id)}>
            -
          </button>
        </div>
      ))}
    </div>
  );
};

export default ShiftBreakComponent;
